import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class compraEstablecimientoService {
    
    /******* QUERIES ******/

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra-establecimiento/paginacion?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra-establecimiento/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}logistica/compra-establecimiento/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/
}

export default new compraEstablecimientoService();